import { LoginBaseModel } from './login-base-model';

export class FacebookLoginModel extends LoginBaseModel {
    constructor (
        authToken: string
    ) {
        super();
        this.token = authToken;
    }

    static toJSON(value: FacebookLoginModel): any {
        return {
            access_token: value.token, 
            version: value.version,
            group_invite_mode: value.groupInviteMode,
            group_invite_key: value.groupInviteKey,
            group_code_mode: value.groupCodeMode,
            group_code: value.groupCode
        };
    }
}
